import { orchestrator } from 'satcheljs';
import { addSelectedCalendar, selectedCalendarsUpdated } from '../actions/publicActions';
import { addSelectedCalendarInStore } from '../actions/internalActions';
import { getSelectedCalendarsForMailbox } from '../selectors/getSelectedCalendarsForMailbox';
import { updateSelectedCalendarsState } from '../services/updateSelectedCalendarsState';

orchestrator(addSelectedCalendar, actionMessage => {
    const { calendarId, primarySmtpAddress } = actionMessage;
    addSelectedCalendarInStore(calendarId, primarySmtpAddress);
    const updatedCalendars = getSelectedCalendarsForMailbox(primarySmtpAddress);
    selectedCalendarsUpdated(updatedCalendars, primarySmtpAddress);
    updateSelectedCalendarsState(updatedCalendars, primarySmtpAddress);
});
